var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { getCurrentRouteSection } from '../../../helpers';
import { useMemo } from 'react';
import query from 'syf-component-library/const/mediaQueries';
import RenderIf from 'syf-component-library/ui/atoms/RenderIf';
import Inline from 'syf-component-library/ui/spacing/Inline';
import Stack from 'syf-component-library/ui/spacing/Stack';
import { useMainContext } from '../../../context';
import useMediaQuery from '../../../hooks/use-media-query';
import useTranslation from '../../../hooks/use-translation';
import { StyledFlex, StyledText, StyledTitle } from '../../subcomponents';
import HandHoldingHeartGraphic from '../HandHoldingHeartGraphic';
import { PaymentOptionsBannerWrapper } from './subcomponents';
var PaymentOptionsBanner = function () {
    var i18n = useTranslation();
    var isMobile = useMediaQuery(query.lessThanSmall);
    var currentRoute = useMainContext().currentRoute;
    var isPaymentOptions = currentRoute === 'payment.options';
    var currentSection = getCurrentRouteSection(currentRoute);
    var _a = useMemo(function () {
        switch (currentSection) {
            case 'plan':
                return {
                    title: i18n('plan.reviewBannerHeading'),
                    body: i18n('plan.reviewBannerText')
                };
            case 'settlement':
                return {
                    title: i18n('settlement.optionsHeading'),
                    body: i18n('settlement.optionsSubHeading')
                };
            default:
                return {
                    title: i18n('paymentOptions.heading'),
                    body: i18n('settlement.optionsSubHeading')
                };
        }
    }, [currentSection, i18n]), title = _a.title, body = _a.body;
    return (_jsx(PaymentOptionsBannerWrapper, __assign({ all: "large" }, { children: _jsxs(StyledFlex, __assign({ direction: isMobile ? 'column' : 'row', alignItems: isMobile ? 'center' : undefined }, { children: [_jsxs(StyledFlex, { children: [_jsx(HandHoldingHeartGraphic, { width: 140 }), _jsx(Inline, { size: "medium" })] }), _jsxs(StyledFlex, __assign({ direction: "column", justifyContent: "center" }, { children: [_jsx(StyledTitle, __assign({ as: "h3", size: currentSection === 'plan' ? 'medium' : 'large', weight: "light", align: isMobile ? 'center' : 'left' }, { children: title })), _jsx(RenderIf, __assign({ condition: isMobile }, { children: _jsx(Stack, { size: "medium" }) })), _jsx(RenderIf, __assign({ condition: !isPaymentOptions }, { children: _jsx(Stack, { size: "small" }) })), _jsx(RenderIf, __assign({ condition: !isPaymentOptions }, { children: _jsx(StyledText, __assign({ align: isMobile ? 'center' : 'left' }, { children: body })) }))] }))] })) })));
};
export default PaymentOptionsBanner;
//# sourceMappingURL=index.js.map